<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Control de Habitaciones</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
              <b-col md="10"></b-col>
              <b-col md="2">
                <b-input-group>
                  <b-form-input
                    v-model="search"
                    class="form-control"
                    @keyup="ChangeSearch"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="mLoadListRoomControl">
                      <b-icon icon="search"></b-icon
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered table-lg mt-lg mb-0">
                <thead>
                  <tr>
                    <th width="3%"  class="text-center">#</th>
                    <th width="9%"  class="text-center">Clase</th>
                    <th width="5%"  class="text-center">Nro</th>
                    <th width="30%"  class="text-center">Cliente</th>
                    <th width="8%"  class="text-center">In</th>
                    <th width="8%"  class="text-center">Out</th>
                    <th width="5%"  class="text-center">Horas</th>
                    <th width="8%"  class="text-center">Hab</th>
                    <th width="8%"  class="text-center">fri</th>
                    <th width="8%"  class="text-center">Pro</th>
                    <th width="8%"  class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item,index) in room_control_rc" :key="index">
                  <tr :class="item.state == 0 ? 'bg-success':'bg-danger'">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-left">{{ item.type_room_name }}</td>
                    <td class="text-left">
                      <button type="button" class="btn btn-info">{{ item.room_number }}</button>
                    </td>
                    <td class="text-left">{{ item.client_name }}</td>
                    <td class="text-center">{{ item.start_date }}</td>
                    <td class="text-center">{{ item.final_date }}</td>
                    <td class="text-center">{{ item.hours }}</td>
                    <td class="text-center">
                      <button type="button" v-if="item.state == 1" @click="ShowModalRoom(item.id_room,item.id_room_control)" class="btn btn-warning form-control text-right">{{ item.room_price }}</button>
                    </td>
                    <td class="text-center">
                      <button type="button" v-if="item.state == 1" @click="ShowModalMinibar(item.id_room_control)" class="btn btn-warning form-control text-right">{{ item.minibar_price }}</button>
                    </td>
                    <td class="text-center">
                      <button type="button" v-if="item.state == 1" @click="ShowModalConsumer(item.id_room_control)" class="btn btn-warning form-control text-right">{{ item.consumer_price }}</button>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="item.state == 0" @click="ShowModalNewRoomControl(item.id_room)">Nuevo</b-dropdown-item>
                        <b-dropdown-item v-if="item.state == 1" >Detalle</b-dropdown-item>
                        <b-dropdown-item v-if="item.state == 1" @click="ShowModalPayment(item.id_room_control)" >Pagar</b-dropdown-item>
                        <b-dropdown-item v-if="item.state == 1" >Anular</b-dropdown-item>
                        <b-dropdown-item v-if="item.state == 2" >Mantenimiento</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


    <ModalMinibar/>
    <ModalConsumer/>
    <ModalRoom/>
    <ModalNewRoomControl/>
    <ModalPayment/>
  </div>
</template>
<style scoped>
  td{
    vertical-align: middle;
  }
</style>>
<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState,mapMutations,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";

// MODULES
import ModalMinibar from './components/ModalMinibar'
import ModalConsumer from './components/ModalConsumer'
import ModalRoom from './components/ModalRoom'
import ModalNewRoomControl from './components/ModalNewRoomControl'
import ModalPayment from './components/ModalPayment'


export default {
  name: "ControlHabitacionList",
  components:{
      ModalMinibar,
      ModalConsumer,
      ModalRoom,
      ModalNewRoomControl,
      ModalPayment
  },
  data() {
    return {
      module:'RoomControl',
      search:'',
    };
  },
  mounted() {
    this.mLoadListRoomControl();
   
  },
  methods: {
    ChangeSearch,
    ShowModalMinibar,
    ShowModalConsumer,
    ShowModalRoom,
    ShowModalNewRoomControl,
    ShowModalPayment,
    ...mapActions('RoomControl',['mLoadListRoomControl']),
    ...mapActions('RoomControl',['mShowModalMinibar']),
    ...mapMutations('RoomControl',['mListRoomControl','mSetSearch'])
  },

  computed: {
    ...mapState(["url_base"]),
    ...mapState('RoomControl',['room_control_rc']),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function ChangeSearch() {
  this.mSetSearch(this.search);
}


// abrir modal frigobar
function ShowModalMinibar(id_room_control) {
  EventBus.$emit('ModalMinibarShow',id_room_control);
}
// abrir modal consumer
function ShowModalConsumer(id_room_control) {
  EventBus.$emit('ModalConsumerShow',id_room_control);
}
// abrir modal consumer
function ShowModalRoom(id_room,id_room_control) {
  // let data = { id_room:id_room,id_room_control:id_room_control };
  EventBus.$emit('ModalRoomShow',id_room,id_room_control);
}
// abrir modal nuevo control habitacion
function ShowModalNewRoomControl(id_room) {
  EventBus.$emit('ModalNewRoomControlShow',id_room);
}
// abrir modal nuevo control habitacion
function ShowModalPayment(id_room_control) {
  EventBus.$emit('ModalPaymentShow',id_room_control);
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
